import { render, staticRenderFns } from "./EditActivityLmsModal.vue?vue&type=template&id=28e97bdc&scoped=true&"
import script from "./EditActivityLmsModal.vue?vue&type=script&lang=js&"
export * from "./EditActivityLmsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditActivityLmsModal.vue?vue&type=style&index=0&id=28e97bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e97bdc",
  null
  
)

export default component.exports